/**
 * Agora.io Configuration
 * 
 * IMPORTANT: 
 * - App ID: ใช้ใน Client-side (React app)
 * - App Certificate: ใช้เฉพาะ Server-side (Firebase Functions หรือ Backend)
 * 
 * Setup Instructions:
 * 1. สมัคร Agora account: https://www.agora.io/
 * 2. สร้าง Project ใน Agora Console
 * 3. ใส่ App ID ใน .env file: REACT_APP_AGORA_APP_ID=your_app_id
 * 4. สำหรับ Production: สร้าง Token Service ใน Firebase Functions
 */

// Debug: Log environment variable
const agoraAppId = process.env.REACT_APP_AGORA_APP_ID || '';
console.log('🔧 Agora Config Debug:', {
  hasAppId: !!agoraAppId,
  appIdLength: agoraAppId.length,
  appIdPreview: agoraAppId ? `${agoraAppId.substring(0, 8)}...` : 'NOT SET',
  allEnvKeys: Object.keys(process.env).filter(key => key.includes('AGORA'))
});

export const agoraConfig = {
  // App ID - ใส่ใน .env file
  appId: agoraAppId,
  
  // App Certificate - ใช้เฉพาะ Server-side เท่านั้น!
  // อย่าใส่ใน Client-side
  // appCertificate: process.env.AGORA_APP_CERTIFICATE || '', // Server-side only
};

// Log config on load
if (agoraConfig.appId) {
  console.log('✅ Agora App ID loaded successfully');
} else {
  console.warn('⚠️ Agora App ID is missing! Please set REACT_APP_AGORA_APP_ID in .env');
}

// Token Service URL (ถ้ามี Firebase Functions)
export const tokenServiceUrl = process.env.REACT_APP_AGORA_TOKEN_SERVICE_URL || '';

export default agoraConfig;
